import { render } from "./TopbarUser.vue?vue&type=template&id=273415f5"
import script from "./TopbarUser.vue?vue&type=script&lang=js"
export * from "./TopbarUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__